export function getFullPhaseTitle<T extends{phaseNumber:number, title:string|null}>(phase: T): string {
	if (phase.phaseNumber.toString() === phase.title) {
		return phase.title;
	}

	return `${phase.phaseNumber.toString().padStart(2, "0")} - ${phase.title}`;
}
